import { render, staticRenderFns } from "./DragHandleIcon.vue?vue&type=template&id=361e405e"
import script from "./DragHandleIcon.vue?vue&type=script&lang=ts"
export * from "./DragHandleIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports